import React from 'react';
import { cn } from './cn';

/**
 * Status pill.
 *
 * The tints are low-alpha washes rather than solid colours, so they composite
 * correctly on every surface in the ramp instead of only the one they were
 * picked against.
 */
const TONES = {
  neutral: 'bg-surface-raised text-ink-muted',
  success: 'bg-success-tint text-success',
  warning: 'bg-warning-tint text-warning',
  danger: 'bg-danger-tint text-danger',
  info: 'bg-info-tint text-info',
};

export const Badge = ({ tone = 'neutral', className, ...props }) => (
  <span
    className={cn(
      'inline-flex items-center gap-1.5 rounded-pill px-2.5 py-[3px]',
      'text-caption-sm font-semibold whitespace-nowrap',
      TONES[tone],
      className
    )}
    {...props}
  />
);

export default Badge;
